import React, { useEffect } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import MainForm from "./form"
import LandingHeader from "./landingheader"
import SssList from "./ssslist"
import Notes from "./notes"
import { pushGtmValues } from "@bappweb/utils"
import Descriptions from "./descriptions"

const Landing = () => {
    useEffect(() => {
        pushGtmValues({
            event: "virtual_page_view",
            content_group: "pos_basvurusu",
            pageName: '/basvuru/pos-basvurusu/0/landing',
            pageTitle: 'POS Başvurusu'
        })
    }, []);

    return (
        <Block>
            <LandingHeader />
            <MainForm />
            <Notes />
            <Descriptions />
            <SssList />
        </Block>
    )
}

export default Landing
